<template>
  <div class="page-add">
    <div class="add-title">调查问卷{{ edit ? "编辑" : "新增" }}</div>
    <class-survey
      :examTypeData="examTypeData"
      :publicData="publicData"
      @changeExamType="changeExamType"
      ref="classExam"
      @selectStudents="selectStudents"
      :edit="edit"
    ></class-survey>
    <div class="handle">
      <el-button size="small" @click="resetForm">重置</el-button>
      <el-button size="small" type="primary" @click="submit">提交</el-button>
      <back-button :pathOptions="pathOptions" :floatLeft="false" />
    </div>
    <!-- <member-select @addSucceed="$router.back()"></member-select> -->
    <SelectStudents
      :studentDialog="showDialog"
      :examId="examId"
      :defaultId="defaultId"
      @closeSelect="closeSelect"
      v-if="showDialog.show"
    />
  </div>
</template>

<script>
import ClassSurvey from "./classSurvey";
import SelectStudents from "./selectStudents.vue";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
import moment from "moment";
import { getInvestigationInfo } from "@/api/investigation";
import BackButton from "@/components/backButton/index.vue";
export default {
  components: {
    ClassSurvey,
    // MemberSelect
    SelectStudents,
    BackButton,
  },
  data() {
    return {
      pathOptions: {
        path: "/investigation",
      },
      investigationType: "0",
      examTypeData: [],
      publicData: [],
      edit: false,
      showDialog: {
        show: false,
      },
      examId: null,
      defaultId: null,
    };
  },
  created() {
    this.getSysParamByTypes(["INVESTIGATION_TYPE", "IS_VALID"]);
    if (this.$route.query.id) {
      this.edit = true;
      this.getInvestigationInfo();
    }
  },
  beforeDestroy() {},
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.examTypeData = res.data["INVESTIGATION_TYPE"]
          .sort(function (a, b) {
            return parseInt(a.paramKey) - parseInt(b.paramKey);
          })
          .map((ele) => {
            ele.paramKey = parseInt(ele.paramKey);
            return ele;
          });
        this.publicData = res.data["IS_VALID"]
          .sort(function (a, b) {
            return parseInt(a.paramKey) - parseInt(b.paramKey);
          })
          .map((ele) => {
            ele.paramKey = parseInt(ele.paramKey);
            return ele;
          });
      });
    },
    getInvestigationInfo() {
      getInvestigationInfo(this.$route.query.id).then((res) => {
        if (!res || res.code != 0) return;
        this.investigationType = res.data.investigationType;
        this.$nextTick(() => {
          let obj = Object.assign({}, res.data);
          if (res.data.limitStartTime) {
            obj.examTime = [
              moment(res.data.limitStartTime),
              moment(res.data.limitEndTime),
            ];
          }
          this.$refs["classExam"].examForm = obj;
        });
      });
    },
    changeExamType(e) {
      this.investigationType = e;
      this.$refs["classExam"].reset();
    },
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        this.$refs["classExam"].reset();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    submit() {
      if (this.edit) {
        this.$refs["classExam"].submit(this.$route.query.id);
      } else this.$refs["classExam"].submit();
    },
    selectStudents(examId) {
      this.showDialog = { show: true };
      this.examId = examId;
    },
    closeSelect(isBack) {
      this.showDialog = { show: false };
      if (isBack) {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.handle {
  margin-top: 30px;
  text-align: center;
}
</style>
